/* eslint-disable no-script-url */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-redeclare */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import React, { Component, useMemo } from 'react';
import { Link, IndexLink } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import { TbPlus } from "react-icons/tb";
import LogoHeader from '../../../assets/icons/nestleheader.svg'
import WeatherMapComponent from "../../layouts/weathermap";
// Import custom components
import Search from './search.component';
import UserMenu from './user-menu.component';
import Notification from './notification.component';
import Language from './language.component';
import $ from "jquery";
import redirectURL from "../../redirectURL";
import CustomerSupport from './CustomerSupport';
import ReportIssue from './reportIssue';
import { getDecoder } from '../utils';

class Header extends Component {

    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.memoizedValue = getDecoder(); // computed once
        this.state = {
            sidebar: false,
            topbar: false,
            navMenus: false,
            outerb: 'show-m',
            outerb1: 'show-n',
            overly: "show-n",
            addTicketSlider: '',
            sliderRouteTranslate: "",
            sliderTranslate: "",
            sliderLoader: 'show-n',
            pbodyc: 'pbdy',
            tpmenu: require('../../../assets/icons/TOP-NAV.png'),
            sTop: 'tp40',
            mTop: 'tp10',
            showAlert: "show-m",
            tmenu: '',
            searchbar: false,
            loginType: "",
            userroles: "",
            favorites: [],
            departmentData: [],
            user: {},
            show: false,
            basicTitle: '',
            basicType: '',
            detailedWeatherMap: 0,
            feeds:[]
        }
        this.setSliderLoader = this.setSliderLoader.bind(this);
        this.closeAddSlider = this.closeAddSlider.bind(this);
        this.showSweetAlert = this.showSweetAlert.bind(this);
    }

    setSliderLoader = (value) => {
        this.setState({
            sliderLoader: value
        })
    }

    closeAddSlider = () => {
        this.setState({
            addTicketSlider: '',
            overly: 'show-n',
            show: false,
            basicTitle: "",
            basicType: "default"
        })
    }

    showSweetAlert = (show, basicTitle, basicType) => {
        this.setState({
            show: show,
            basicTitle: basicTitle,
            basicType: basicType
        })
    }

    goFull = () => {
        if ((document.fullScreenElement && document.fullScreenElement !== null) ||
            (!document.mozFullScreen && !document.webkitIsFullScreen)) {
            if (document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    openCloseSidebar = () => {
        if (this.state.sidebar) {
            this.setState({ sidebar: false })
            document.querySelector(".page-body-wrapper").classList.add('sidebar-close');
        } else {
            this.setState({ sidebar: true })
            document.querySelector(".page-body-wrapper").classList.remove('sidebar-close');
        }
    }

    onShowAddTicket() {
        this.setState({
            addTicketSlider: "slider-translate-40p",
            overly: 'show-m'
        });
    }

    toggle() {
        this.setState(prevState => ({
            navMenus: !prevState.navMenus
        }));
    }


    openCloseTopbar = () => {
        if (this.state.topbar) {
            this.setState({
                topbar: false,
                tpmenu: require('../../../assets/icons/TOP-NAV.png'),
                outerb: "show-m",
                outerb1: "show-n",
                sTop: "40px",
                tmenu: '',
                mTop: 'tp10',

            })
            document.querySelector(".page-body").classList.remove('pbdy');
            document.querySelector(".page-main-header").classList.remove('topbar-close');
            document.querySelector('.page-sidebar').classList.remove("tp0");
            document.querySelector('.page-sidebar').classList.add("tp40");
        } else {
            this.setState({
                topbar: true,
                tpmenu: require('../../../assets/icons/topnav-blue.png'),
                outerb: "show-n",
                outerb1: "show-m",
                sTop: "0px",
                tmenu: '',
                mTop: 'tp40 r42',
            })
            document.querySelector(".page-body").classList.add('pbdy');
            document.querySelector(".page-main-header").classList.add('topbar-close');
            document.querySelector('.page-sidebar').classList.remove("tp40");
            document.querySelector('.page-sidebar').classList.add("tp0");
        }
    }


    componentWillMount() {
        var contentwidth = window.innerWidth;
        if ((contentwidth) <= 991) {
            this.setState({ sidebar: false })
        }
    }

    componentDidMount() {
        //console.log("Header Sidebar :", this.state.sidebar);
        var contentwidth = window.innerWidth;
        if ((contentwidth) <= 991) {
            document.querySelector(".page-body-wrapper").classList.add('sidebar-close');
        }
        this.setState({
            loginType: localStorage.getItem("user_type"),
            userroles: localStorage.getItem("roles"),
        })
        var loading_port_code = localStorage.getItem("loading_port_code");
        if (loading_port_code != undefined) {
            $("#loadingPlant").val(loading_port_code)
        }


        
        
        // redirectURL.post("/newsfeeds")
        // .then((response) => {
        //     var records = response.data.feeds;
        //     // console.log("records", records);
        //     this.setState({
        //         feeds:records
        //     })
        // })
    }
    changeHandler = (e) => {
        this.setState({
            sliderRouteTranslate: "slider-translate-60p",
            overly: "show-m",
        })
    }
    onChangeLoadingPlant = (e) => {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var selectedPlant = $("#loadingPlant").val();
        var params = {
            selectedPlant: selectedPlant,
        }
        redirectURL.post("/lmconsignees/getLoadingPlantDetails", params)
            .then((response) => {
                var res = response.data;
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                })
                localStorage.setItem('loading_port_code', selectedPlant);
                localStorage.setItem('comp_code', res[0].comp_code);
                window.location.reload();
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }
    onClickHideAll = (event) => {
        this.setState({
            sliderRouteTranslate: "",
            sliderTranslate: "",
            overly: "show-n",
            addTicketSlider: '',
        })
    }
    closeMenuAlert() {
        this.setState({
            showAlert: "show-n"
        })
    }
    onCloseRouteDiv = (event) => {
        this.setState({
            sliderRouteTranslate: "",
            overly: "show-n"
        })
    }
    onShowUploadDiv = () => {
        //console.log("Click DCT Users Button")
        var requestParam = {
            userType: "DCTUSER"
        }
        redirectURL.post("/consignments/getUsersByUserType", requestParam)
            .then(async (response) => {
                var departments = response.data;
                var dctUsers = departments
                //console.log("records",records)
                if (departments.length > 0) {
                    redirectURL.post("/consignments/getUserLoginDetails", { "departments": dctUsers }).then((response) => {
                        console.log("response", response.data)
                        this.setState({
                            departmentData: response.data,
                            loadshow: 'show-n',
                            overly: 'show-n',
                        })
                    }).catch((e) => {
                        console.log(e);
                    })
                }
                else {
                    this.setState({
                        loadshow: 'show-n',
                        overly: 'show-n',
                    })
                }
                this.setState({
                    uploadDivWidth: '30%',
                    sliderTranslate: "slider-translate",
                    showDiv: 'show-m',
                });
            })
            .catch(function (e) {
                console.log("Error ", e)
            })

    }

    onCloseUploadDiv = () => {
        this.setState({
            uploadDivWidth: '0%',
            sliderTranslate: "",
            showDiv: 'show-n',
        });
    }

    onGridReady = params => {
        this.gridApi = params.api;

        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
        var sort = [
            {
                colId: 'username',
                sort: 'asc',
            },
        ];
        this.gridApi.setSortModel(sort);
    }

    closeAlert = () => {
        this.setState({
            show: false,
            alert: false
        })
    }

    render() {
        if (localStorage.getItem('dept_code') == 'SNDG' || localStorage.getItem('dept_code') == '"SNDG"') {
            var dept = ''
        }
        var noPadStyle = {};
        return (
            <div className="page-main-header cus-main-header" id="pheader">
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}>
                </SweetAlert>
                <div className="main-header-left">
                    <div className="logo-wrapper">
                        <a href={"/"}>
                            <img src={require('../../../assets/images/new-logo.png')} alt="header-browser" id = 'logo_img' />
                        </a>
                    </div>
                </div>
                <div className="main-header-right row" style={noPadStyle}>
                    <div className="mobile-sidebar">
                    </div>
                    {this.memoizedValue.role[0] != 'EXIM' ?<div className="nav-right col">
                        <ul className={"nav-menus " + (this.state.navMenus ? 'open' : '') + "ul ol"}>
                            <li className="p-0">
                                <a className="text-dark">
                                    <img className="align-self-center pull-right mr-2" src={LogoHeader} alt="header-browser" id='logo_img' />
                                </a>
                            </li>
                            <li className="p-0">
                                <button title="Create Ticket"
                                    onClick={this.onShowAddTicket.bind(this)}
                                    className={"btn btn-warning action_btn mr-1 display-flex-center-center main-page-button"}
                                    type="button">
                                    <TbPlus size={20} />&nbsp;&nbsp;Create Ticket
                                </button>
                            </li>
                            <li className="p-0">
                                <a href="/" className="txt-dec-none clr333">
                                    <i className="icofont icofont-home"></i>
                                </a>
                            </li>
                            <li className="p-0">
                                <a href="#" className="" onClick={this.changeHandler.bind(this)} style={{ textDecoration: 'none' }}>
                                    <i className="icofont icofont-ui-weather defaultclr"></i>
                                </a>
                            </li>
                            <CustomerSupport />
                            :<Notification />
                            <UserMenu />
                        </ul>
                        <div className="d-lg-none mobile-toggle" onClick={() => this.toggle()}>
                            <i className="icon-more"></i>
                        </div>
                    </div>:
                   <div className="nav-right col">
                        <ul className={"nav-menus " + (this.state.navMenus ? 'open' : '') + "ul ol"}>
                            <li className="p-0">
                                <a className="text-dark">
                                    <img className="align-self-center pull-right mr-2" src={LogoHeader} alt="header-browser" id='logo_img' />
                                </a>
                            </li>
                            <li className="p-0">
                                <a href="/" className="txt-dec-none clr333">
                                    <i className="icofont icofont-home"></i>
                                </a>
                            </li>
                            <CustomerSupport />
                            <UserMenu />
                        </ul>
                        <div className="d-lg-none mobile-toggle" onClick={() => this.toggle()}>
                            <i className="icon-more"></i>
                        </div>
                    </div>}
                </div>
                {this.state.sliderRouteTranslate != '' ?
                    <WeatherMapComponent context={this}
                        sliderValue={this.state.sliderRouteTranslate}
                        onCloseRouteDiv={this.onCloseRouteDiv.bind(this)}
                        detailedWeatherMap={this.state.detailedWeatherMap}
                    />
                    : ""
                }
                <div className={"slide-r " + (this.state.addTicketSlider)} style={{ overflow: "hidden" }}>
                    <h3 className="subH">Create Ticket</h3>
                    <div className="slide-r-body" style={{ position: "relative" }}>
                        <div className={"dataLoad " + (this.state.sliderLoader)} style={{ opacity: "0.5" }}>
                            <div style={{ position: "fixed", left: "50%", top: '50%' }}>
                                <div class="loader-box">
                                    <div class="loader-box">
                                        <div class="rotate dashed colored"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <ReportIssue closeAddSlider={this.closeAddSlider} showSweetAlert={this.showSweetAlert}
                                setSliderLoader={this.setSliderLoader} />
                        </div>
                    </div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
                <a href={"javascript:void(0)"} className={(this.state.tmenu)} id="tmenu">
                    <div id="outer" className={(this.state.outerb)}></div>
                    <div id="outer1" className={(this.state.outerb1)}><div id="sinner">&nbsp;</div></div>
                    <img src={this.state.tpmenu} className={"topmenu " + (this.state.mTop)} defaultChecked={this.state.topbar} onClick={this.openCloseTopbar} alt="" />
                </a>
            </div>

        );
    }
}
$(document).ready(function () {
    $("#sidebar-toggle").click(function () {
        $(".nav-left-arrow").css("display", "none");
        $(".nav-tooltip").css("display", "none");
        $(".close-menu-alert").css("display", "none");
    });
    $(".sidebaropen-icon").click(function () {
        setTimeout(function () {
            $(".nav-left-arrow").css("display", "block");
            $(".nav-tooltip").css("display", "block");
            $(".close-menu-alert").css("display", "block");
        }, 1000)

    });
})


export default Header